module.exports = __webpack_public_path__ + "img/img_title_cooperation.0e00e496.png";